/* @flow */
import UsersPdfInviteInstructions from './UsersPdfInviteInstructions';

export default UsersPdfInviteInstructions;
